<template>
  <tr>
    <template v-for="title in titles">
      <template v-if="!(title === 'Positie' && selectedYear === '2018')">
        <template v-if="!selectableItems.includes(title.toLowerCase())">
          <th :key="title" :class="getClass(title)" v-html="getTitle(title)" />
        </template>
      </template>
    </template>
    <th v-if="selectableItems.length">
      <select v-model="selectedItem" v-on:change="$emit('onSelectChange', selectedItem)">
        <template v-for="(title) in titles">
          <template v-if="selectableItems.includes(title.toLowerCase())">
            <option :key="title" :value="title.toLowerCase()" >
              {{ getTitle(title) }}
            </option>
          </template>
        </template>
      </select>
    </th>
  </tr>
</template>

<script>
import { mapState } from 'vuex';
import { SELECTABLE_ITEMS, TITLES_MAP } from '@/config/list.config';

export default {
  name: 'ListHeader',

  props: {
    /**
     * The titles of the list items
     */
    titles: {
      type: Array,
      required: true,
    },

    selectedTitle: {
      type: String,
      required: false,
    },

    /**
     * Convert the title to specific string
     */
    convertTo: {
      type: String,
      required: false,
      default: 'upperWord',
      validator: (value) => [
        'capitalize',
        'lowerCase',
        'upperCase',
        'upperWord',
      ].includes(value),
    },
  },

  data() {
    return {
      selectableItems: SELECTABLE_ITEMS,
      selectedItem: this.selectedTitle,
    };
  },

  computed: {
    ...mapState({
      selectedYear: (state) => state.rawData.year,
    }),
  },

  methods: {
    getClass(title) {
      if (title === 'Rapportcijfer' || title === 'Positie' || title === 'Trendrating') {
        return 'is-centered';
      }

      return '';
    },

    getTitle(title) {
      let changedTitle = title;

      Object.keys(TITLES_MAP).forEach((key) => {
        if (title.toLowerCase() === key) {
          changedTitle = TITLES_MAP[key].replace('####', this.selectedYear - 1);
        }
      });

      if (title === 'Rapportcijfer') {
        changedTitle = 'Rapport&shy;cijfer';
      }

      if (title === 'Trendrating') {
        changedTitle = 'Trend&shy;rating';
      }

      return this.$options.filters.convertString(changedTitle, this.convertTo);
    },
  },
};
</script>

<style lang="scss" scoped>
  th {
    @include font-size(iota);

    display: flex;
    font-weight: bold;
    padding-bottom: $global-spacing-unit-half;
    padding-right: 0;
    padding-top: 0;
    text-align: left;
    // white-space: nowrap;

    &.is-centered {
      text-align: center;
    }

    &:nth-child(1) {
      flex-shrink: 0;
      width: 40px;
    }

    &:nth-child(2) {
      flex-grow: 1;
    }

    &:nth-child(3) {
      flex-shrink: 0;
      width: 50px;
    }

    &:nth-child(4) {
      flex-shrink: 0;
      width: 76px;
    }

    &:nth-child(5) {
      flex-shrink: 0;
      width: 76px;
    }
  }
</style>
